<template>
    <div>
<!--        <breadcrumb :routerList="[{to:'/guanhuai',title:'用户交互'},{title:'联系人'}]" />-->
      <Breadtabsheader/>
        <div class="h-content">
            <!-- 搜素条件 -->
          <div class="h-piece">
            <div class="h-formBox">
              <el-form :inline="true" :model="q" class="demo-form-inline h-formBorder">
                <div class="h-thirdColumn w-newColumn">
                  <el-form-item label="联系人">
                    <el-input v-model="q.fullName" placeholder="请输入联系人" clearable="clearable"></el-input>
                  </el-form-item>
                  <el-form-item label="客户">
                    <el-input v-model="q.custName" placeholder="请输入名称/编码" clearable="clearable"></el-input>
                  </el-form-item>
                  <!--<el-form-item label="客户名称">-->
                  <!--  <el-select filterable v-model="q.custName" clearable placeholder="请选择"-->
                  <!--  >-->
                  <!--    <el-option-->
                  <!--        v-for="item in userLists"-->
                  <!--        :key="item.userName"-->
                  <!--        :label="item.userName"-->
                  <!--        :value="item.userName">-->
                  <!--    </el-option>-->
                  <!--  </el-select>-->
                  <!--</el-form-item>-->
                  <el-form-item label="部门">
                    <el-input v-model="q.dept" placeholder="请输入部门" clearable="clearable"></el-input>
                  </el-form-item>
                  <el-form-item label="职务">
                    <el-input v-model="q.job" placeholder="请输入职务" clearable="clearable"></el-input>
                  </el-form-item>

                </div>
                <el-collapse-transition>
                  <div v-show="isScreen">
                    <div class="h-thirdColumn w-newColumn">
                      <el-form-item label="创建日期" class="timeselect" style="width: 50%;">
                        <el-date-picker
                            placeholder="请选择"
                            v-model="q.startDate"
                            clearable
                            type="date"
                            value-format="yyyy-MM-dd" >
                        </el-date-picker>
                        <span class="w-time-to">至</span>
                        <el-date-picker
                            placeholder="请选择"
                            v-model="q.endDate"
                            clearable
                            type="date"
                            value-format="yyyy-MM-dd" >
                        </el-date-picker>
                      </el-form-item>

                    </div>
                  </div>
                </el-collapse-transition>
              </el-form>
              <div class="l-screenBox">
                <div class="l-screen" @click="collapseChange">
                  <img :src="isScreen?closeScreen:drawScreen" alt="">
                  <div class="l-screenText">{{isScreen?"收起":"展开"}}</div>
                </div>
                <div class="l-retrieval">
                  <el-button class="h-btn h-formBtn" @click="handleFilter">检索</el-button>
                  <el-button class="h-btn h-formBtn h-bgwhite" @click="rest">重置</el-button>
                  <el-button class="h-btn h-formBtn h-bggreen" icon="el-icon-plus" @click="create">
                    新增
                  </el-button>
                </div>
              </div>
            </div>
          </div>
            <!-- 结果展示 -->
            <div class="h-table h-mrt30 smTableRq ljjtablepaddingsrq">
                <!-- @selection-change="handleSelectionChange" -->
                <el-table
                    ref="multipleTable"
                    :data="tableData"
                    :border="true"

                    max-height="560"
                    style="width: 100%"
                >
                  <el-table-column
                    label="序号"
                     type="index"
                     width="50px">
                  </el-table-column>
                  <el-table-column prop="fullName"  label="联系人" width="80px" ></el-table-column>
                  <el-table-column prop="custName"  label="客户" width="180px" ></el-table-column>
                  <!--<el-table-column prop="custCode"  label="客户编码" width="100px" ></el-table-column>-->
                  <el-table-column prop="leader"  label="客户联系人" width="120px" ></el-table-column>
                  <el-table-column prop="dept"  label="部门" width="80px" ></el-table-column>
                  <el-table-column prop="job" label="职务" width="80px" ></el-table-column>
                  <el-table-column prop="sex" label="性别" width="80px" >
                    <template slot-scope="scope">
                          <span v-if="scope.row.sex == 1">
                            女
                          </span>
                          <span v-if="scope.row.sex == 0">
                            男
                          </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="mobilephone" label="手机" width="150px" ></el-table-column>
                  <el-table-column prop="telephone" label="电话" width="150px" ></el-table-column>
                  <el-table-column prop="email" label="邮件" width="150px" ></el-table-column>
                  <el-table-column prop="address" label="地址" width="100px"></el-table-column>
                  <el-table-column prop="birthday" label="生日" width="100px"></el-table-column>
                  <el-table-column prop="policyMaker" label="关键决策人" width="80px" >
                    <template slot-scope="scope">
                          <span v-if="scope.row.policyMaker == 0">
                            否
                          </span>
                           <span v-if="scope.row.policyMaker == 1">
                            是
                          </span>
                    </template>
                  </el-table-column>
                  <el-table-column prop="finishSchool" label="毕业院校" width="80px" ></el-table-column>
                  <el-table-column prop="expertlevel" label="专家级别" width="80px" ></el-table-column>
                  <el-table-column prop="interest" label="业余兴趣" width="80px" ></el-table-column>
                  <!--<el-table-column prop="project" label="国家级科研项目" width="100px" ></el-table-column>-->
                  <el-table-column prop="memo" label="备注" width="100px" ></el-table-column>
                  <el-table-column prop="cdate" label="创建时间" width="100px" ></el-table-column>
                  <el-table-column
                      label="操作"
                      fixed="right"
                      width="90"
                  >
                    <template slot-scope="scope">
                      <div v-if="scope.row.id " style="text-align: left;">
                        <!--<el-button-->
                        <!--    type="text"-->
                        <!--    size="small"-->
                        <!--    class="h-tableLink h-btn"-->
                        <!--    @click="showSummarizes(scope.row.id)"-->
                        <!--&gt;总结</el-button>-->
                        <el-button
                            type="text"
                            size="small"
                            class="h-tableLink h-btn"
                            @click="updateDetail(scope.row)"
                        >修改</el-button>
                        <el-button
                            type="text"
                            size="small"
                            style="padding: 0;"
                            class="h-tableLink h-btn"
                            @click="deleteSingle(scope.row.id)">
                          删除
                        </el-button>
                      </div>
                    </template>
                  </el-table-column>
                </el-table>
            </div>
        </div>

      <!-- 新增弹出层 -->
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="newDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1">

              <el-form-item  label="联系人" prop='fullName'>
                <el-input v-model="add.fullName" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="客户名称" prop="custName" >
                <el-select v-model="add.custName" remote :disabled="this.disabled"
                           filterable :filter-method="showFormList" clearable placeholder="请输入"
                           :remote-method="showFormList" @change="showFormList" >
                  <el-option v-for="(item) in optionList"
                             :key="item.id"
                             :label="item.userName"
                             :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item  label="客户联系人" prop='leader' >
                <el-input v-model="add.leader" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="部门" prop='dept' >
                <el-input v-model="add.dept" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="职务" prop='dept' >
                <el-input v-model="add.job" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item
                  label="性别"
                  prop="sex"
              >
                <el-radio-group v-model="add.sex">
                  <el-radio :label="0">男</el-radio>
                  <el-radio :label="1">女</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item  label="手机" prop='mobilephone'
                             :rules="[
                {
                  pattern: /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/,
                  message: '请输入正确的手机号码'
                }
              ]">
                <el-input v-model="add.mobilephone" onkeyup="value=value.replace(/[^\d]/g,'')" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="电话" prop='telephone'
                             :rules="[
                {
                  pattern: /[0-9-()（）]{7,18}/,
                  message: '请输入正确的电话号码'
                }
                ]">
                <el-input v-model="add.telephone" onkeyup="value=value.replace(/[^\d]/g,'')" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="邮件" prop='email'
                             :rules="[
                {
                  pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                  message: '请输入正确邮件'
                }
                ]"
              >
                <el-input v-model="add.email" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="地址" prop='address'>
                <el-input v-model="add.address" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="生日">
                <el-date-picker
                    v-model="add.birthday"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item
                  label="决策人"
                  prop="policyMaker"
              >
                <el-radio-group v-model="add.policyMaker">
                  <el-radio :label="0">否</el-radio>
                  <el-radio :label="1">是</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item  label="毕业院校" prop='finishSchool' >
                <el-input v-model="add.finishSchool" :disabled="this.disabled" placeholder="请输入">{{finishSchool}}
                </el-input>
              </el-form-item>

              <el-form-item  label="业余兴趣" prop='interest' >
                <el-input v-model="add.interest" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="国家级科研项目" prop='project' >
                <el-input v-model="add.project" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="备注" prop="memo">
                <el-input v-model="add.memo" :disabled="this.disabled" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item label="专家级别" class="h-elformWrap-1">
                <el-input type="textarea" v-model="add.expertlevel" placeholder="请输入" class="h-txtareaBox" rows="3" clearable></el-input>
              </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
          </div>
        </div>
      </el-dialog>

      <!-- 修改弹出层 -->
      <el-dialog :close-on-click-modal="false"  @close='closeDialog' :visible.sync="editDialog" class="h-dialog2">
        <div class="h-dialogImg">
          <div class="h-disTable">
            <div class="h-tableCell">
              <h1>{{titleDig}}</h1>
            </div>
          </div>
        </div>
        <div class="h-formLines">
          <div style="padding: 12px;">
            <el-form :model="add" label-position="right" :inline="true" label-width="80" :rules="editFormRules"
                     class="demo-ruleForm h-formbLine h-formbLine1">

              <el-form-item  label="联系人" prop='fullName'>
                <el-input v-model="add.fullName" :disabled="this.disabled"  placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="客户名称" prop="custName" >
                <el-select v-model="add.custName" remote :disabled="this.disabled"
                           filterable :filter-method="showFormList" clearable placeholder="请输入"
                           :remote-method="showFormList" @change="showFormList" >
                  <el-option v-for="(item) in optionList"
                             :key="item.id"
                             :label="item.userName"
                             :value="item.userName">
                  </el-option>
                </el-select>
              </el-form-item>

              <el-form-item  label="客户联系人" prop='leader' >
                <el-input v-model="add.leader" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="部门" prop='dept' >
                <el-input v-model="add.dept" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="职务" prop='dept' >
                <el-input v-model="add.job" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item
                  label="性别"
                  prop="sex"
              >
                <el-radio-group v-model="add.sex">
                  <el-radio :label='"0"'>男</el-radio>
                  <el-radio :label='"1"'>女</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item  label="手机" prop='mobilephone'
                             :rules="[
                {
                  pattern: /^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/,
                  message: '请输入正确的手机号码'
                }
              ]">
                <el-input v-model="add.mobilephone" onkeyup="value=value.replace(/[^\d]/g,'')" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="电话" prop='telephone'
                             :rules="[
                {
                  pattern: /[0-9-()（）]{7,18}/,
                  message: '请输入正确的电话号码'
                }
                ]">
                <el-input v-model="add.telephone" onkeyup="value=value.replace(/[^\d]/g,'')" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="邮件" prop='email'
                             :rules="[
                {
                  pattern: /^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/,
                  message: '请输入正确邮件'
                }
                ]"
              >
                <el-input v-model="add.email" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="地址" prop='address'>
                <el-input v-model="add.address" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="生日">
                <el-date-picker
                    v-model="add.birthday"
                    type="date"
                    value-format="yyyy-MM-dd"
                    placeholder="选择日期">
                </el-date-picker>
              </el-form-item>

              <el-form-item
                  label="决策人"
                  prop="policyMaker"
              >
                <el-radio-group v-model="add.policyMaker">
                  <el-radio :label='"0"'>否</el-radio>
                  <el-radio :label='"1"'>是</el-radio>
                </el-radio-group>
              </el-form-item>

              <el-form-item  label="毕业院校" prop='finishSchool' >
                <el-input v-model="add.finishSchool" :disabled="this.disabled" placeholder="请输入">{{finishSchool}}
                </el-input>
              </el-form-item>

              <el-form-item  label="业余兴趣" prop='interest' >
                <el-input v-model="add.interest" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item  label="国家级科研项目" prop='project' >
                <el-input v-model="add.project" :disabled="this.disabled" placeholder="请输入">
                </el-input>
              </el-form-item>

              <el-form-item label="备注" prop="memo">
                <el-input v-model="add.memo" :disabled="this.disabled" placeholder="请输入"></el-input>
              </el-form-item>

              <el-form-item label="专家级别" class="h-elformWrap-1">
                <el-input type="textarea" v-model="add.expertlevel" placeholder="请输入" class="h-txtareaBox" rows="3" clearable></el-input>
              </el-form-item>

            </el-form>
          </div>
          <div style="display:flex;justify-content:center;margin-bottom:20px">
            <el-button class="h-btn h-bBtn h-bgwhite" @click="exit">取消</el-button>
            <el-button class="h-btn h-bBtn h-bgblueQ2" @click="commitCreate()">提交</el-button>
          </div>
        </div>
      </el-dialog>




      <div class="h-tableB h-mrt30">
          <div class="h-tableBL" style="margin-left: 23px">
            <el-button class="h-btn h-formBtn h-bgblueQ" icon="h-el-icon h-el-icon-import"
                       @click="exportExcel">批量导出
            </el-button>
          </div>
          <div class="h-pagination2">
            <pagination :page="q" @query="query" style="padding-top: 0.1rem"/>
          </div>
        </div>

    </div>
</template>
<script>
import ss from "../../../api/SystemService";
import updownfile from '../../../utils/updownfile'
import util from "../../../utils/util";
import customerDetailsService from "../../../api/loud/credit/customerDetailsService";
import uploaddownexcel from '../../../components/uploaddown/uploaddownexcel'
import cost from '../../../routes/cost';
import moment from "moment";
export default {
    data() {
    return {
      // 展开折叠筛选
      isScreen: false,
      closeScreen: require("@/assets/images/pimg/closeallic.png"),
      drawScreen: require("@/assets/images/pimg/dobleArr.png"),
      q: {
        fullName: '',
        custName: '',
        custCode: '',
        leader: '',
        dept: '',
        job: '',
        endDate: '',
        startDate: '',
        username: '',
        pageSize: 10,
        pageNo: 1,
        total: 0,
      },
      size: '',
      tableData: [
        {
          fullName: '',
          custName: '',
          custCode: '',
          leader: '',
          dept: '',
          job: '',
          sex: '',
          mobilephone: '',
          telephone: '',
          email: '',
          address: '',
          birthday: '',
          achievingRate: '',
          finishSchool: '',
          expertlevel: '',
          interest: '',
          project: '',
          memo: '',
          cdate: '',
        }
      ],
      add: {
        id: '',
        fullName: '',
        custName: '',
        custCode: '',
        leader: '',
        dept: '',
        job: '',
        sex: 0,
        mobilephone: '',
        telephone: '',
        email: '',
        address: '',
        birthday: '',
        policyMaker: 0,
        achievingRate: '',
        finishSchool: '',
        expertlevel: '',
        interest: '',
        project: '',
        memo: '',
      },
      times: [],
      qweekList: [],
      sexList: [0, 1],
      newDialog: false,
      writeNissin: false,
      editDialog: false,
      yearList: [new Date().getFullYear(), new Date().getFullYear() + 1],
      weekList: [],
      nissin: {
        answerTime: '',
        defultFlag: '',
        dailyQuestion: '',
        customerName: '',
        visitDate: '',
        endDate: '',
        visitContent: "",
        dailyContent: '',
        isProject: 0,
        id: '',
        isConShow: false,
        isProjectBtn: false,
        chainGroupName: '',
        chainGroupCode: '',
        visitEffect: '',
        title: '',
        statusR: '',
        selectVisitEffect: ['a', 'b'],
        gameTitles: [],
        subJieProgess: [], // 需求子节点数据
        childMsgId: '',
        //yucePrice: '', // 月预算在下单
        expConvDate: '',
        department: '',
        telephone: '',
        contactUserName: "",
        lianqunCode: '',
      },

      authTypeListEdit: [],
      wirteNissinList: [],
      disEdit: false,
      workList: [],
      deptList: [],
      userLists: [],
      custNameList: [],
      AuthoCheck: '',
      authTypeList: [],
      userList: [0],
      weekPlanList: [],
      groupList: [],
      groupArr: [],
      titleDig: "",
      optionList: [],
      projectList: [],
      qyearList: [],
      editFormRules: {
        // cuname: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        // customerChannel: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        // city: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        // projectName:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // probjectSorts:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // chanceType:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // expOnlineDate:[{required: true, message: '请输入必填项', trigger: 'change'}],
        // expConvDate:[{required: true, message: '请输入必填项', trigger: 'change'}],
        // scenesType:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // area:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // documentaryType:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // statusR:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        // lianqun:[{required: true, message: '请输入必填项', trigger: 'blur'}],
        fullName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
        custName: [{required: true, message: '请输入必填项', trigger: 'blur'}],
      },
    }
  },
    methods: {
    //明细导出
    exportExcel() {
      updownfile.down("/api/swyl/v1/guanhuai/bscContactPerson/newDownloadExcel", this.q, "post", 'data');
    },
    showFormList(value) {
      ss.MuBiao.getUser(value).then(res => {
        this.optionList = res.msg
      })
      if (this.optionList.length == 1) {
        this.custCode = this.optionList.userCode;
      }
    },
    //项目类型
    getProject() {
      ss.MuBiao.getProject().then(res => {
        this.projectList = res.msg
      })
    },
    // getDept(q){
    //   ss.MuBiao.getDeptList(q).then(rd => {
    //     this.deptList = rd;
    //   })
    // },
    getcust(q) {
      ss.MuBiao.getUser(q).then(rd => {
        this.userLists = rd;
      })
    },
    getcustName(q) {
      ss.MuBiao.getUser(q).then(rd => {
        this.custNameList = rd;
        // console.log("-------------------")
        // console.log(this.custNameList);
      })
    },

    getKnowWeek() {
      var week1 = this.getWeekNum();
      this.qweekList.forEach(element => {
        if (week1 == element.week) {
          this.q.week = element.week
        }
      });
    },
    getqWeeks(y, z) {
      ss.MuBiao.getWeekList({year: y, stype: z}).then(rd => {
        this.qweekList = rd;
        this.getKnowWeek();
      })
    },
    groupListMe() {
      var data = this.add.customerName
      ss.MuBiao.getUser(data).then(res => {
        this.groupList = []
        this.groupArr = []
        this.groupList = res.msg
        for (let item of this.groupList) {
          this.groupArr.push({
            value: item.userName,
            id: item.userCode
          })
        }
      })
    },

    //获取今年是第几周
    getWeekNum() {
      //获得当前日期是第几周的方法
      var year = new Date().getFullYear();
      var week = moment(new Date()).format("E");//获得今天是星期几
      var startweek = moment(new Date(year + "-01-01")).format("E");//获得今年的1月1号是星期几
      //今天到1月1号的时间戳之差
      var millisDiff =
          new Date(moment().format("yyyy-MM-DD")).getTime() -
          new Date(year + "-01-01").getTime();
      var days =
          (millisDiff -
              week * (24 * 60 * 60 * 1000) -
              (7 - startweek) * (24 * 60 * 60 * 1000)) /
          86400000;
      return days / 7;
      //这里加的2代表的是本周和今年1月1号所在的那一周
    },

    //改动和并列的
    arraySpanMethod() {
      this.$nextTick(() => {
        if (this.$refs.multipleTable.$el) {
          var current = this.$refs.multipleTable.$el
              .querySelector(".el-table__footer-wrapper")
              .querySelector(".el-table__footer");
          var cell = current.rows[0].cells;
          cell[0].style.display = "none";
          cell[1].style.display = "none";
          cell[2].style.display = "none";
          cell[3].style.display = "none";
          cell[4].style.display = "none";
          cell[5].style.display = "none";
          cell[10].style.display = "none";
          cell[6].classList.remove('is-left');
          cell[6].colSpan = "7";
        }
      })
    },

    query() {
      this.selectPageAll()
    },

    deleteSingle(id) {
      //
      var data = id
      this.$confirm('确定删除该数据, 是否继续?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        ss.MuBiao.deleteById(data).then(res => {
          console.log(res)
          if (res.f == true) {
            this.$message({
              type: 'success',
              message: '删除成功!'
            });
            this.selectPageAll()
          } else {
            this.$message.error(res.msg);
          }
        })

      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        });
      });

    },
    updateDetail(row) {
      //
      this.authTypeListEdit = []
      this.titleDig = "修改内容"
      var data = row.id
      console.log("id"+data)
      ss.MuBiao.getbscConcactpersonSinglep(data).then(res => {
        console.log("--------------");
        console.log(res.msg);
        // this.authTypeListEdit = res.msg;
        this.add = res.obj;
        console.log("-----------555555----");
        console.log(this.add);
        // console.log(this.authTypeList);
        // if(res.msg.clearType == 1){
        //   var obj=res.msg.detailList1.find(function (obj) {
        //     return obj.status ==1//取出this.studentL里的id为1的那条数据所有的信息
        //   })
        //   this.disEdit = true
        //   this.edit.deId = obj.id
        // }else{
        //   this.disEdit = false
        //   this.edit.deId = res.msg.detailList1[0].id
        // }
        //res.msg.id
        // this.edit.userList.push("202108077fbF2uAn")
        // this.edit.id = res.msg.id
        // this.edit.customerName = row.customerName
        // this.edit.projectName = row.projectName
        // this.edit.visitDateNew = row.visitDate
        // this.edit.targetContent = row.visitContent
        // this.edit.clearType = res.msg.clearType
      })
      console.log(row)
      this.editDialog = true
    },

    selectPageAll() {
      ss.MuBiao.getBsccontactperson(this.q).then(res => {
        this.tableData = res.records
        // console.log(this.tableData);
        // console.log(res);
        this.q.total = res.total;

      })
    },
    querySearchGroup(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup(val) {
      this.add.customerName = val.value
    },
    groupListMe1() {
      var data = this.edit.customerName
      ss.MuBiao.getUser(data).then(res => {
        this.groupList = []
        this.groupArr = []
        this.groupList = res.msg
        for (let item of this.groupList) {
          this.groupArr.push({
            value: item.userName,
            id: item.userCode
          })
        }
      })
    },
    querySearchGroup1(queryString, cb) {
      var groupArr = this.groupArr;
      cb(groupArr);
    },
    selectGroup1(val) {
      this.edit.customerName = val.value
    },
    changeHandler(value) {
      //console.log('改变之后的值是:' + value)
      let data = this.authTypeList
      let item = this.add.userList
      // 使用find方法根据id查询对应对象
      let a = data.find((ele) => {
        return ele.id == item
      });
      var arr3 = a
      if (!arr3.id) {
        this.add.targetContent = '',
            this.add.customerName = ''
        this.add.clearType = 2
        this.disEdit = true
      } else {
        this.add.targetContent = arr3.targetContent,
            this.add.customerName = arr3.customerName
        this.add.clearType = 1
        this.add.projectName = arr3.projectName
        this.disEdit = false
        this.add.id = this.add.userList
      }
    },
    handleFilter() {
      this.query();
    },
    groupChange() {
      if (this.add.userList.length > 1) {
        this.add.userList.shift();
      }
      var arr3 = []
      this.add.userList.forEach((item) => {
        this.authTypeList.forEach((element) => {
          if (item == element.id) {
            arr3.push(element)
          }
        })
      })
      if (arr3.length == 0) {
        this.add.targetContent = '',
            this.add.customerName = ''
        this.add.clearType = 2
        this.disEdit = false
      } else {
        this.add.targetContent = arr3[0].targetContent,
            this.add.customerName = arr3[0].customerName
        this.add.clearType = 1
        this.add.projectName = arr3[0].projectName
        this.disEdit = true
        this.add.id = this.add.userList[0]
      }
    },

    //获得周计划列表
    getWeekPlan(year, week) {
      var year = this.add.year
      var week = parseInt(this.add.week)
      var data = {
        year: year,
        week: week
      }
      ss.MuBiao.getListPlan(data).then(res => {
        if (res.f == true) {
          this.authTypeList = res.msg
        } else {
          this.$message.error(res.msg);
        }
      })
    },

    getNowTime() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth(); //得到月份
      var date = now.getDate(); //得到日期
      month = month + 1;
      month = month.toString().padStart(2, "0");
      date = date - 1;
      date = date.toString().padStart(2, "0");
      var defaultDate = `${year}-${month}-${date}`;
      this.$set(this.q, "planCreateTime", defaultDate);
    },

    getWeeks(y) {
      ss.MuBiao.getWeekList({year: y}).then(rd => {
        this.weekList = rd;
      })
    },
    getWeeksBySelectYear() {
      this.getWeeks(this.add.year);
      ss.createMonthGoal.getLianQunByUser(this.add).then(rd => {
        this.addlianqunList = rd;
      })
    },

    selectWeek() {
      this.getWeekPlan()
    },
    getqWeeksBySelectYear() {
      this.getqWeeks(this.q.year, 1);
    },
    // 展开折叠
    collapseChange() {
      this.isScreen = !this.isScreen;
    },
    create() {
      this.newDialog = true;
      this.titleDig = "新建联系人"
      // this.add.week = this.weekList[0].week
      this.getWeekPlan()
    },
    rest() {
      this.q.fullName = '',
          this.q.custName = '',
          this.q.custCode = '',
          this.q.leader = '',
          this.q.dept = '',
          this.q.job = '',
          this.q.endDate = '',
          this.q.startDate = '',
          this.q.username = ''
    },


    exit() {
      this.closeDialog()
    },
    commitCreate() {

      if (!this.add.fullName) {
        this.$message({
          type: "error",
          message: '联系人不能为空'
        });
        return false;
      }

      if (!this.add.custName) {
        this.$message({
          type: "error",
          message: '客户名称不能为空'
        });
        return false;
      }

      if (this.add.mobilephone != '') {
        if (!/^((1[3,5,8,7,9][0-9])|(14[5,7])|(17[0,6,7,8])|(19[1,7]))\d{8}$/.test(this.add.mobilephone)) {
          this.$message({
            type: "error",
            message: '手机号格式不正确！'
          });
          return false;
        }
      }

      if (this.add.telephone != '') {
        if (!/[0-9-()（）]{7,18}/.test(this.add.telephone)) {
          this.$message({
            type: "error",
            message: '电话格式不正确！'
          });
          return false;
        }
      }
      if (this.add.email != '') {
        if (!/^([A-Za-z0-9_\-\.])+\@([A-Za-z0-9_\-\.])+\.([A-Za-z]{2,4})$/.test(this.add.email)) {
          this.$message({
            type: "error",
            message: '邮箱地址格式不正确！'
          });
          return false;
        }
      }
      ss.MuBiao.insertbcp(this.add).then(res => {
        console.log(res)
        if (res.f == true) {
          this.$message({
            message: res.msg,
            type: 'success'
          });
          this.selectPageAll()
          //this.newDialog = false
          this.closeDialog()
        } else {
          this.closeDialog()
          this.$message.error(res.msg);
        }
      })

    },
    mounted() {
      this.selectPageAll();
    },
    closeDialog() {
      this.newDialog = false
      this.editDialog = false

      this.add.id = '',
      this.add.fullName = '',
      this.add.custName = '',
      this.add.custCode = '',
      this.add.leader = '',
      this.add.dept = '',
      this.add.job = '',
      this.add.sex = 0,
      this.add.mobilephone = '',
      this.add.telephone = '',
      this.add.email = '',
      this.add.address = '',
      this.add.birthday = '',
      this.add.policyMaker = 0,
      this.add.achievingRate = '',
      this.add.finishSchool = '',
      this.add.expertlevel = '',
      this.add.interest = '',
      this.add.project = '',
      this.add.memo = ''

      // this.edit.targetContent = '',
      // this.edit.customerName = '',
      // this.edit.projectName = ''

    },
  },
    watch: {
      'add.customerName': {
        deep: true,
        handler: function (newVal, oldVal) {
          this.groupArr = [];//这是定义好的用于存放下拉提醒框中数据的数组
          var len = this.groupList.length;//groupList
          var arr = [];
          for (var i = 0; i < len; i++) {//根据输入框中的值进行模糊匹配
            if (this.groupList[i].name.indexOf(this.add.customerName) >= 0) {
              arr.push({
                value: this.groupList[i].name,
                id: this.groupList[i].id
              })
            }
          }
          this.groupArr = arr
        }
      },
    },
    created() {
      this.getcust();
      // this.getWeeks(new Date().getFullYear());
      // this.getqWeeks(new Date().getFullYear(),1);
      // for(var i =2021;i<new Date() .getFullYear()+2;i++){
      //   this.qyearList.push(i);
      // }
      this.handleFilter();
      this.getProject()
      // this.getNowTime();
      // if(this.getWeekNum() == 0){
      //   this.q.week = '52'
      //   this.q.year =new Date().getFullYear()-1
      // }else {
      //   this.q.week = this.getWeekNum();
      //   this.q.year =new Date().getFullYear();
      // }
    }

}
</script>
<style scoped>
    /* 修改弹出窗布局 (字段 展示 问题) */
    /deep/ .h-formbLine .el-form-item__label{
        width:90px;
    }
    /deep/  .h-formbLine .el-form-item__content{
        width:150px;
    }
    /deep/ .h-elformWrap-1 .el-form-item__content{
        width: 78%;
    }

    /*.projectCon p{*/
    /*  justify-content: space-between;*/
    /*  align-items:center;*/
    /*  font-size: 14px;*/
    /*  border-bottom:#1b78e6 1px dashed;*/
    /*  padding: 5px 0;*/
    /*  margin: 0 auto 10px auto;*/
    /*  color: #1b78e6;*/
    /*}*/
</style>